import React from 'react';
import PageTemplate from '../../components/PageTemplate';

const DevOps = () => {
  return (
    <PageTemplate title="DevOps Solutions" subtitle="Streamline your development lifecycle" breadcrumb="Services > DevOps">
      <div className="content-section">
        <h3>DevOps & Kubernetes</h3>
        <p>Advanced DevOps practices, CI/CD pipelines, and Kubernetes orchestration.</p>
      </div>
    </PageTemplate>
  );
};

export default DevOps; 